<template>
    <div class="page m-trainPlan">
        <div class="btn-group">
            <button :class="{'active': status=='Pending'}" @click="statusChange('Pending')">待审批</button>
            <button :class="{'active': status=='Success'}" @click="statusChange('Success')">已审批</button>
            <button :class="{'active': status=='Fail'}" @click="statusChange('Fail')">未通过</button>
        </div>

       <div id="asset" class="asset-wrap">

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="'编号'">
                <el-input v-model="formSearch.number" :placeholder="'请输入编号'"
                          @keyup.enter.native="getStandingBookData(1)" clearable></el-input>
            </el-form-item>
            <el-form-item label="经办人">
                <el-input v-model="formSearch.approver" :placeholder="$t('tip.name')" clearable></el-input>
            </el-form-item>
            <el-form-item label="创建人">
                <el-input v-model="formSearch.creator" :placeholder="$t('tip.name')" clearable></el-input>
            </el-form-item>
            <!-- 培训教室 -->
        <el-form-item :label="'培训教室'">
            <el-select v-model="formSearch.roomId" clearable :placeholder="$t('tip.select')">
                <el-option :label="item.name" :value="item.id" :key="item.id"
                        v-for="item in serviceRoom" style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
        <!-- 服务项 -->
        <el-form-item :label="'服务项'">
            <el-select v-model="formSearch.equipmentId" clearable :placeholder="$t('tip.select')">
                <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in equipments" style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
            <el-form-item label="预约日期">
                <el-date-picker
                    v-model="formSearch.startReserveTime"
                    type="date"
                    :placeholder="'选择预约日期'"
                    :picker-options="reserveStartPickerOptions"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span> {{$t('c.to')}} </span>
                <el-date-picker
                    v-model="formSearch.endReserveTime"
                    type="date"
                    :placeholder="'选择预约日期'"
                    :picker-options="reserveEndpickerOptions"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
               </el-form-item>
               <el-form-item label="创建日期">
                <el-date-picker
                    v-model="formSearch.startCreateTime"
                    type="date"
                    :placeholder="'选择创建日期'"
                    :picker-options="createStartPickerOptions"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span> {{$t('c.to')}} </span>
                <el-date-picker
                    v-model="formSearch.endCreateTim"
                    type="date"
                    :placeholder="'选择创建日期'"
                    :picker-options="createEndpickerOptions"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary"  @click="getStandingBookData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">

            <data-tables class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}">


                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 :width="title.width" :min-width="title.minWidth"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>

                <el-table-column :label="$t('c.operation')" align="center" width="150px">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview"
                           :title="$t('c.view')"
                           @click="viewStandingBook(scope.row)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>

    </div>

    <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';

    export default {
        data() {
            return {
                status:'Pending',
                //搜索条件相关
                formSearch: {
                    number: '',
                    roomId: '',
                    equipmentId: '',
                    creator: '',
                    approver:'',
                    startReserveTime: '',
                    endReserveTime: '',
                    startCreateTime: '',
                    endCreateTim: '',
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                serviceRoom:[],
                equipments:[],
                currentPage: 1,
                titles: [
                    {
                        prop: 'number',
                        label: '编号'
                    },{
                        prop: 'title',
                        label: '培训内容',
                        minWidth: '180px'
                    },
                    {
                        prop: 'roomName',
                        label: '会议室'
                    }, {
                        prop: 'reserveTime',
                        label: '预约日期',
                        width: '190px',
                        sortable: 'custom'
                    }, {
                        prop: 'duration',
                        label: '预约时间段',
                        width: '280px',
                    },{
                        prop: 'approverName',
                        label: '经办人',
                        sortable: 'custom'
                    }, {
                        prop: 'creatorName',
                        label: '创建人',
                        sortable: 'custom'
                    }, {
                        prop: 'createTime',
                        label: '创建日期',
                        sortable: 'custom',
                        width: '190px',
                    }, {
                        prop: 'status',
                        label: '状态',
                        sortable: 'custom'
                    },
                ],
            }
        },
        created() {
            api.getRoomQuery().then(res => {
                       this.serviceRoom = res.package;
                        }).catch((error) => {
                            console.log(error);
                        });
                        api.getEquipmentQuery().then(res => {
                        this.equipments = res.package;

                        }).catch((error) => {
                            console.log(error);
                        });
             this.getStandingBookData();
        },
        computed: {
            reserveStartPickerOptions() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endReserveTime) return false;
                        return time.getTime() > new Date(that.formSearch.endReserveTime).getTime()
                    },
                }
            },
            reserveEndpickerOptions() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startReserveTime) return false;
                        let dateTime = new Date(that.formSearch.startReserveTime);
                        dateTime=dateTime.setDate(dateTime.getDate()-1);
                        return time.getTime() < new Date(dateTime).getTime()
                    },
                }
            },
           createStartPickerOptions() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.endCreateTim) return false;
                        return time.getTime() > new Date(that.formSearch.endCreateTim).getTime()
                    },
                }
            },
            createEndpickerOptions() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.startCreateTime) return false;
                        let dateTime = new Date(that.formSearch.startCreateTime);
                        dateTime=dateTime.setDate(dateTime.getDate()-1);
                        return time.getTime() < new Date(dateTime).getTime()
                    },
                }
            },
        },
        methods: {
            statusChange(status){
                this.status = status;
                this.formSearch={
                    number: '',
                    roomId: '',
                    equipmentId: '',
                    creator: '',
                    approver:'',
                    startReserveTime: '',
                    endReserveTime: '',
                    startCreateTime: '',
                    endCreateTim: '',
                };
                this.getStandingBookData(1);
            },
          getStandingBookData(page) {
                if(page) this.currentPage = page;
                let queryData = {
                    status:this.status,
                    ...this.formSearch
                    };

                api.reserveRoomQuery(queryData).then(res => {
                    let data = res.package;

                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 16) + " — "
                            + (data[i].endTime && data[i].endTime.substring(0, 16) || '');
                        data[i].reserveTime = data[i].startTime.substring(0, 10)+'—'+data[i].endTime.substring(0, 10);
                        data[i].title = data[i].title?data[i].title:'-';
                        data[i].approverName = data[i].approverName?data[i].approverName:'-';
                        data[i].status = data[i].status==1?'待审批':data[i].status==2?'已审批':data[i].status==3?'未通过':data[i].status==0?'已保存':'已过期';
                        data[i].createTime = data[i].createTime && data[i].createTime.split(' ')[0];
                    }

                    this.tableData = data;
                })
            },

            //查看台账
            viewStandingBook(data) {
                this.$router.push({name: 'assetDetail', params: {assetId: data.id}})
            },
            onSubpageClose() {
                if (Ticket.get()) this.getStandingBookData()
            }

        },
        components: {

        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';
    .btn-group {
        margin-bottom: 20px;
        button {
            margin-right: 10px;
            padding: 8px 28px;
            outline: 0;
            color: #2f3238;
            background-color: #fff;
            border: 1px solid #fff;
            border-radius: 2px;
            cursor: pointer;

            &.active {
                background-color: $color-theme;
                color: #fff;
            }
        }
    }
    .asset-wrap{
        height: 100%;
    }
    .page-table{
        height: 78%;
    }
    .form-table {
        display: flex;
        flex: 1;
        flex-direction: column;
    }
</style>
